import React from "react";
import { Modal, Button } from "react-bootstrap";
import { IMAGE_PATHS } from '../Functions/Constant';
import ButtonsVariant from '../Components/Button/ButtonVariant'; // Fixed: Use default import


const WelcomeModal = ({ show, handleClose }) => {
    localStorage.removeItem("welcome_popup");
    const handleSetupProfile = () => {
        // const expireDate = new Date();
        // expireDate.setFullYear(expireDate.getFullYear() + 10); // aaj se 10 saal baad
        // document.cookie = `welcome_modal_seen=true; path=/; expires=${expireDate.toUTCString()}`

        window.location.href = "/profile";
        handleClose();
    };
    return (
        <Modal show={show} onHide={handleClose} centered backdrop="static" keyboard={false} >
            <Modal.Header closeButton className="p-4 !border-b-0">
            </Modal.Header>
            <Modal.Body className="text-center p-5 rounded-[25px]">
                {/* Welcome Image */}
                <img
                    src={IMAGE_PATHS.WelcomePopup}
                    alt="Welcome"
                    className="mx-auto mb-2 w-[280px] h-auto"
                />

                <h6 className="font-semibold text-black text-center w-full mb-0 mt-[0px] pb-[5px]">Welcome to JobCritics!</h6>

                <p className="text-gray-600 text-center text-[17px] leading-[1.6] pb-[15px]">Unlock your career potential! Update your education and experience to connect with colleagues and managers for valuable feedback and ratings.</p>

                {/* Button */}
                {/* <Button
                    onClick={handleSetupProfile}
                    className="btn-explore-yellow w-full"
                >
                    Get Started Now!
                </Button> */}
                <ButtonsVariant
                    ariaLabel="button"
                    href="#"
                    onClick={handleSetupProfile}
                    className="mx-[10px] !w-[24%]  sm:!w-[32%] xs:!w-[36%]"
                    variant="blackToWhite"
                    size="md"
                    title="Ok"
                    iconPosition="after" // or "before" as you prefer
                />
            </Modal.Body>
        </Modal>
    );
};

export default WelcomeModal;
